/*
 *
 * DimensionByTeam reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_WATCHER,
  GRAPHIC_BARS_FAILED,
  GRAPHIC_BARS_SUCCESS,
  GRAPHIC_BARS_WATCHER,
  GET_HISTORY_BY_TEAM_WATCHER,
  GET_HISTORY_BY_TEAM_SUCCESS,
  GET_HISTORY_BY_TEAM_FAILED,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_QUESTIONS_WATCHER,
  GET_QUESTIONS_SUCCESS,
  GET_QUESTIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  divisions: [],
  dimensions: [],
  team: [],
  metricTotal: {},
  graphicBars: [],
  isLoadingGraphicBars: true,
  showHistory: false,
  ifFirst: false,
  showVariation: true,
  switchMoreDimensions: false,
  graphicPeakonTeam: {},
  isLoadingGraphicPeakonTeam: false,
  measureColorRange: null,
  measureInfo: {},
  questionList: [],
})

function dimensionByTeamReducer(state = initialState, action) {
  switch (action.type) {
    case GRAPHIC_BARS_WATCHER:
      return state.set("graphicBars", []).set("isLoadingGraphicBars", true)
      .set('evolutionData', [])
      .set('evolutionLines', [])
      .set('graphicPeakonTeam',{})

    case GRAPHIC_BARS_SUCCESS:
      return state
        .set("graphicBars", action.payload)
        .set("isLoadingGraphicBars", false)

    case GRAPHIC_BARS_FAILED:
      return state.set("graphicBars", []).set("isLoadingGraphicBars", false)

    case GET_QUESTIONS_SUCCESS:
        return state.set("questionList", action.payload)

    case GET_DIVISIONS_WATCHER:
      return state.set("divisions", [])

    case GET_DIVISIONS_SUCCESS:
      return  state
        .set("divisions", action.payload.data)
        .set('ifFirst', action.payload.ifFirst)
        .set("showHistory", action.payload.showHistory)

    case GET_DIMENSIONS_WATCHER:
      return state
        .set("isLoading", true)
        .set("dimensions", [])
        .set("team", [])
        .set("showHistory", false)
        .set("switchMoreDimensions", false)

    case GET_DIMENSIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set("dimensions", action.payload.dimensions)
        .set("team", action.payload.team)
        .set("metricTotal", action.payload.metricTotal)
        .set("showHistory", action.payload.showHistory)
        .set("switchMoreDimensions", action.payload.switchMoreDimensions)
        .set("measureInfo", action.payload.measureInfo)

    case GET_HISTORY_BY_TEAM_WATCHER:
      return state
        .set("graphicPeakonTeam", {})
        .set("isLoadingGraphicPeakonTeam", true)
        .set('graphicBars', [])

    case GET_HISTORY_BY_TEAM_SUCCESS:
      return state
        .set("graphicPeakonTeam", action.payload)
        .set("isLoadingGraphicPeakonTeam", false)
        .set('evolutionData', action.payload.dataValues)
        .set('evolutionLines', action.payload.dataLines)

    case GET_HISTORY_BY_TEAM_FAILED:
      return state
        .set("graphicPeakonTeam", {})
        .set("isLoadingGraphicPeakonTeam", false)

    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set("measureColorRange", action.payload.report_color_range)
    default:
      return state
  }
}

export default dimensionByTeamReducer
